import React, { useState, useEffect } from "react";
const CheckBox = ({ options, selected, onChange, questionKey }) => {
  const [checkedState, setCheckedState] = useState(
    options.map(option =>
      selected[questionKey] ? selected[questionKey].includes(option.PK_ID) : false
    )
  );
  const [selectAllChecked, setSelectAllChecked] = useState(
    checkedState.every((isChecked) => isChecked)
  );
  // Add an effect to update checkboxes when questionKey changes
  useEffect(() => {
    if (selected[questionKey] !== undefined) {
      setCheckedState(
        options.map(option =>
          selected[questionKey] ? selected[questionKey].includes(option.PK_ID) : false
        )
      );
    }
  }, [questionKey, options, selected]);
  // Add an effect to update selectAllChecked when checkedState changes
  useEffect(() => {
    setSelectAllChecked(checkedState.every((isChecked) => isChecked));
  }, [checkedState]);
  const handleOptionChange = (position) => {
    const updatedCheckedState = [...checkedState];
    updatedCheckedState[position] = !checkedState[position];
    setCheckedState(updatedCheckedState);
    // Build an array of PK_ID values for selected checkboxes
    const selectedPKs = updatedCheckedState
      .map((isChecked, index) => (isChecked ? options[index].PK_ID : null))
      .filter((pk) => pk !== null);
    onChange(questionKey, selectedPKs);
  };
  const handleSelectAllChange = () => {
    const updatedCheckedState = Array(options.length).fill(!selectAllChecked);
    setSelectAllChecked(!selectAllChecked);
    setCheckedState(updatedCheckedState);
    // Build an array of PK_ID values for selected checkboxes
    let selectedPKs = updatedCheckedState.map((isChecked, index) =>
      isChecked ? options[index].PK_ID : null
    );
    if(selectAllChecked) {
      selectedPKs = [];
    }
    
    onChange(questionKey, selectedPKs);
  };
  return (
    <div className="option-box-outer">
      <div className="option-box col-md-12 select-all">
        <label className="option-label">
          <div className="input-container">
            <input
              type="checkbox"
              checked={selectAllChecked}
              onChange={handleSelectAllChange}
            />
            Select All
          </div>
        </label>
      </div>
      {options.map((option, position) => (
        <div key={position} className="option-box">
          <label className="option-label">
            <div className="input-container">
              <input
                type="checkbox"
                value={option.PK_ID}
                checked={checkedState[position]}
                onChange={() => handleOptionChange(position)}
              />
              {option.VALUE}
            </div>
          </label>
        </div>
      ))}
    </div>
  );
};
export default CheckBox;